import React from 'react';

import {ScoresListWidgetProps} from "../../models/scores-list-widget.props";


export class ScoresListWidgetCompetitionEmptyStateProps extends ScoresListWidgetProps {
  label: String;
}

export const ScoresListWidgetCompetitionEmptyState = (props: ScoresListWidgetCompetitionEmptyStateProps) => {
  return (
    <div className={'scores-list-widget-competition-empty-state'}>
      {props.label}
    </div>
  )
}
